import React, { useState, useEffect } from 'react';
import { getMessages, createMessage, deleteMessage } from '../services/api';
import { FiPlus, FiTrash2, FiX } from 'react-icons/fi';

const Messages = () => {
  const [messages, setMessages] = useState<any[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [form, setForm] = useState({ titre: '', to_user_id: '', service: '', message: '' });

  const loadData = () => {
    getMessages().then(r => {
      setMessages(r.data);
    }).catch(() => {});
  };

  useEffect(() => { loadData(); }, []);

  const resetForm = () => setForm({ titre: '', to_user_id: '', service: '', message: '' });

  const openAdd = () => { resetForm(); setShowModal(true); };

  const formatDate = (d: string) => {
    if (!d) return '-';
    const dt = new Date(d);
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(dt.getDate())}/${pad(dt.getMonth() + 1)}/${dt.getFullYear()} ${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
  };

  const truncate = (text: string, max: number) => {
    if (!text) return '-';
    return text.length > max ? text.substring(0, max) + '...' : text;
  };

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await createMessage(form);
      setSuccess('Message envoyé avec succès');
      setShowModal(false);
      loadData();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Erreur');
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm('Supprimer ce message ?')) return;
    await deleteMessage(id);
    loadData();
  };

  return (
    <div>
      <h1 className="page-title">Messages</h1>

      {success && <div className="alert alert-success">{success}</div>}
      {error && <div className="alert alert-error">{error}</div>}

      <div className="card">
        <div className="card-header">
          <span>Messages ({messages.length})</span>
          <button className="btn btn-success" onClick={openAdd}><FiPlus /> Nouveau message</button>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="data-table">
              <thead>
                <tr><th>Date</th><th>De</th><th>Titre</th><th>Message</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {messages.map(m => (
                  <tr key={m.id}>
                    <td>{formatDate(m.created_at || m.date)}</td>
                    <td>{m.from_name || '-'}</td>
                    <td>{m.titre || '-'}</td>
                    <td>{truncate(m.message, 80)}</td>
                    <td>
                      <div className="actions">
                        <button className="btn-icon btn-danger" onClick={() => handleDelete(m.id)}><FiTrash2 /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Nouveau message</h3>
              <button className="modal-close" onClick={() => setShowModal(false)}><FiX /></button>
            </div>
            <form onSubmit={handleSave}>
              <div className="modal-body">
                <div className="form-group"><label>Titre</label><input className="form-input" value={form.titre} onChange={e => setForm({ ...form, titre: e.target.value })} required /></div>
                <div className="form-row">
                  <div className="form-group"><label>Destinataire (ID)</label><input className="form-input" value={form.to_user_id} onChange={e => setForm({ ...form, to_user_id: e.target.value })} placeholder="Optionnel" /></div>
                  <div className="form-group"><label>Service</label><input className="form-input" value={form.service} onChange={e => setForm({ ...form, service: e.target.value })} /></div>
                </div>
                <div className="form-group"><label>Message</label><textarea className="form-input" style={{ minHeight: '120px' }} value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} required /></div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-outline" onClick={() => setShowModal(false)}>Annuler</button>
                <button type="submit" className="btn btn-primary">Envoyer</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Messages;
